import { forwardRef } from 'react';

import { useAuthUser } from 'auth/hooks';
import { FormProvider } from 'core/states';
import { ITaxonomyGroup, ITaxonomyPath } from 'taxonomy/types';

import { upsertTaxonomyGroupSchema } from './schema';
import { UpsertTaxonomyGroupFormFields } from './UpsertTaxonomyGroupFormFields';

interface IProps {
  defaultTaxonomyPath?: ITaxonomyGroup | ITaxonomyPath[];
}

export const UpsertTaxonomyGroup = forwardRef(function UpsertTaxonomyGroup(props: IProps, ref) {
  const { user } = useAuthUser();

  return (
    <FormProvider
      schema={upsertTaxonomyGroupSchema(
        Boolean(user.companySettings.taxonomyRequired),
        user.companySettings.taxonomyLevel
      )}
    >
      <UpsertTaxonomyGroupFormFields ref={ref} {...props} />
    </FormProvider>
  );
});
